import { DjangoLiveSidebar } from './live/DjangoLiveSidebar'
import type { Project, ActiveWorkflow } from '@/types/conversations'

interface DjangoLiveSectionProps {
  project: Project
  processing: boolean
  conversationId?: number
  onDeploy: () => void
  onRedeploy: () => void
  onRestart: () => void
  onViewDeployedInHistory?: () => void
  activeWorkflow?: ActiveWorkflow | null
  onAbortWorkflow?: () => void
  onRetryWorkflow?: () => Promise<void>
  isAbortingWorkflow?: boolean
  isRetryingWorkflow?: boolean
}

export function DjangoLiveSection({
  project,
  processing,
  conversationId,
  onDeploy,
  onRedeploy,
  onRestart,
  activeWorkflow,
  onAbortWorkflow,
  onRetryWorkflow,
  isAbortingWorkflow,
  isRetryingWorkflow,
}: DjangoLiveSectionProps) {
  return (
    <DjangoLiveSidebar
      project={project}
      processing={processing}
      conversationId={conversationId}
      onDeploy={onDeploy}
      onRedeploy={onRedeploy}
      onRestart={onRestart}
      activeWorkflow={activeWorkflow}
      onAbortWorkflow={onAbortWorkflow}
      onRetryWorkflow={onRetryWorkflow}
      isAbortingWorkflow={isAbortingWorkflow}
      isRetryingWorkflow={isRetryingWorkflow}
    />
  )
}
